module.exports = __webpack_public_path__ + "static/media/barratio.570ca271.jpg";